const splittedSpecialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`.split("");


export function passwordCompliance(rules, val) {
  const data = {}
  //console.log('rules', rules)
  if (rules.size.max) {
    if (val.length >= rules.size.min && val.length <= rules.size.max)
      data.pwdLengthOk = true;
    else data.pwdLengthOk = false;
  } else if (val.length < rules.size.min) data.pwdLengthOk = false;
  else data.pwdLengthOk = true;
  // nombre de majuscule
  if (rules.char.upper.authorized) {
    const nbUpper = val.length - val.replace(/[A-Z]/g, "").length;
    if (rules.char.upper.max) {
      if (
        nbUpper >= rules.char.upper.min &&
        nbUpper <= rules.char.upper.max
      )
        data.pwdUpperOk = true;
      else data.pwdUpperOk = false;
    } else if (nbUpper < rules.char.upper.min) data.pwdUpperOk = false;
    else data.pwdUpperOk = true;
  } else data.pwdUpperOk = true;

  // nombre de minuscule
  if (rules.char.lower.authorized) {
    const nbLower = val.length - val.replace(/[a-z]/g, "").length;
    if (rules.char.lower.max) {
      if (
        nbLower >= rules.char.lower.min &&
        nbLower <= rules.char.lower.max
      )
        data.pwdLowerOk = true;
      else data.pwdLowerOk = false;
    } else if (nbLower < rules.char.lower.min) data.pwdLowerOk = false;
    else data.pwdLowerOk = true;
  } else data.pwdLowerOk = true;

  // nombre de chiffre
  if (rules.number.authorized) {
    const nbNumber = val.length - val.replace(/[0-9]/g, "").length;
    if (rules.number.max) {
      if (nbNumber >= rules.number.min && nbNumber <= rules.number.max)
        data.pwdNumberOk = true;
      else data.pwdNumberOk = false;
    } else if (nbNumber < rules.number.min) data.pwdNumberOk = false;
    else data.pwdNumberOk = true;
  } else data.pwdNumberOk = true;

  // check caractère spéciaux
  if (rules.special.authorized) {
    const u = splittedSpecialChars.filter(
      (x) => rules.special.include.indexOf(x) === -1
    );
    const pp = u.filter((x) => val.split("").includes(x));
    if (pp.length > 0) data.pwdSpecialOk = false;
    else {
      const res = rules.special.include.map(
        (e) => val.split("").filter((k) => k === e).length
      );
      const numberSpecial = res.reduce((a, b) => a + b, 0);
      if (rules.special.max) {
        if (
          numberSpecial >= rules.special.min &&
          numberSpecial <= rules.special.max
        )
          data.pwdSpecialOk = true;
        else data.pwdSpecialOk = false;
      } else if (numberSpecial < rules.special.min)
        data.pwdSpecialOk = false;
      else data.pwdSpecialOk = true;
    }
  } else data.pwdSpecialOk = true;

  return data;
}